import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

interface Props {
  fullName: string;
  size?: number;
}

/**
 * Round avatar with the first-name initial. Matches the team-information
 * MembersTab styling: black circle + white letter on light mode, inverted
 * on dark mode. Single-character only (initialsFor() in utils/avatar.ts
 * stays available for places that want two letters).
 */
export function Avatar({ fullName, size = 40 }: Props) {
  const { isDark } = useTheme();
  const trimmed = (fullName || '').trim();
  const initial = trimmed ? trimmed.charAt(0).toUpperCase() : '?';
  const palette = isDark ? 'bg-white text-black' : 'bg-black text-white';
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-semibold shrink-0 ${palette}`}
      style={{ width: size, height: size, fontSize: Math.max(11, Math.round(size * 0.4)) }}
    >
      {initial}
    </span>
  );
}
